import { SELECT_CHANNEL, RECEIVED_GAMES } from '../actions/index';

const INITIAL_STATE = {
    games: []
}

const rootReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RECEIVED_GAMES:
            return { ...state, games: action.games };
        default:
            return state;
    }
};
export default rootReducer;